@if (_context) {
    <mat-tab-group class="detail-tabs">
        <mat-tab label="Infos">
            <app-document-type-form
                [disabled]="_context.formMode === FormMode.Reading"
                [context]="_context.formContext"
                [documentType]="_context.formContext.item"
                (documentTypeUpdated)="onDocumentTypeUpdated($event)"
                (canceled)="onCanceled($event)"></app-document-type-form>
        </mat-tab>
    </mat-tab-group>
}
